<div>
    <div class="container text-center mt-4 mb-2">
        <img src="./assets/images/logo-ust.svg" alt="logo" class="img-fluid" style="height: 120px;" />
    </div>
</div>
<div style="background-color:#114B43; height:900px">
    <div class="container pt-4 pb-4">
        <fieldset style="background: #eee !important;">
    
                <div class="container" style="background: #9cb93f; vertical-align:middle;">
                    <br>
                    <h2 class="titlex" style="text-align: left;">Pago rechazado por webpay</h2>
                    <h5 class="titlex mb-2" style="text-align: left;">Volver al proceso o cambiar el medio de pago.</h5>
                    <br>
                </div>
                <div class="form">
          
                    <div class="alert alert-success ml-4 mt-4 mb-4 mr-4" role="alert" >
                        <h4 class="alert-heading">No se puede procesar el pago.</h4>
                        <hr>
                        <a href="/" class="btn btn-block btn-primary">volver</a>
                    </div>
                </div>
           
        </fieldset>
    </div>
</div>